import { render, staticRenderFns } from "./flight-ticket.vue?vue&type=template&id=052175fb&scoped=true&"
var script = {}
import style0 from "./flight-ticket.vue?vue&type=style&index=0&id=052175fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052175fb",
  null
  
)

export default component.exports